/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'
import SiteReferrer from '../model/SiteReferrer'

/**
 * SiteReferrer service.
 * @module api/SiteReferrerApi
 * @version 1.0.0
 */
export default class SiteReferrerApi {
  /**
   * Constructs a new SiteReferrerApi.
   * @alias module:api/SiteReferrerApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  constructor(apiClient) {
    this.apiClient = apiClient || ApiClient.instance
  }

  /**
   * OTA一覧を取得する
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/SiteReferrer>} and HTTP response
   */
  searchSiteReferrersWithHttpInfo() {
    let postBody = null

    let pathParams = {}
    let queryParams = {}
    let headerParams = {}
    let formParams = {}

    let authNames = ['Bearer']
    let contentTypes = ['application/json']
    let accepts = ['application/json']
    let returnType = [SiteReferrer]

    return this.apiClient.callApi('/site_referrers/search', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType)
  }

  /**
   * OTA一覧を取得する
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/SiteReferrer>}
   */
  searchSiteReferrers() {
    return this.searchSiteReferrersWithHttpInfo().then(function(response_and_data) {
      return response_and_data.data
    })
  }
}
